export class Box<T> {
    value: T
}
